module.exports = __webpack_public_path__ + "static/icon_uic.9938363b.png";